<template>
  <header
    class="bg-white border-b border-slate-200 shadow-[0_1px_3px_rgba(0,0,0,0.06)]"
    style="font-family: 'Plus Jakarta Sans', Inter, sans-serif;"
  >
    <div class="tw-flex justify-between items-center w-full max-w-[1440px] mx-auto px-6 lg:px-12 h-14">

      <!-- Logo -->
      <span
        class="tw-flex items-center cursor-pointer hover:opacity-[0.85] transition-opacity mr-6 flex-shrink-0"
        @click="$router.push('/dashboards/home')"
      >
        <img
          src="/images/static-home-page/samergo/zhe-bar.png"
          alt="ZHE-BAR"
          class="h-8 w-auto object-contain"
        />
      </span>

      <!-- Desktop nav -->
      <nav class="hidden md:tw-flex items-center gap-1 overflow-x-auto flex-1">
        <span
          v-for="item in navItems"
          :key="item.key"
          class="text-[0.78rem] py-1.5 px-3 cursor-pointer font-medium uppercase whitespace-nowrap border-b-2 transition-[color,border-color] duration-150"
          :class="checkIsActive(item.key)
            ? 'text-[#071c5b] font-bold border-[#071c5b]'
            : 'text-slate-500 border-transparent hover:text-[#071c5b]'"
          @click="navigate(item.path)"
        >{{ item.label }}</span>
      </nav>

      <!-- Mobile hamburger -->
      <button
        class="md:hidden p-2 rounded-lg bg-transparent border-none cursor-pointer tw-flex items-center justify-center hover:bg-slate-100 transition-colors"
        @click="mobileMenuOpen = !mobileMenuOpen"
      >
        <span class="material-symbols-outlined text-[#071c5b]">{{ mobileMenuOpen ? 'close' : 'menu' }}</span>
      </button>

    </div>

    <!-- Mobile nav dropdown -->
    <div
      v-if="mobileMenuOpen"
      class="md:hidden border-t border-slate-100 bg-white px-6 py-3 tw-flex flex-col gap-1"
    >
      <span
        v-for="item in navItems"
        :key="item.key"
        class="text-[0.95rem] py-3 px-2 rounded-lg cursor-pointer transition-colors duration-150 font-medium"
        :class="checkIsActive(item.key)
          ? 'text-[#071c5b] font-bold bg-[#f0f2ff]'
          : 'text-slate-600 hover:text-[#071c5b] hover:bg-slate-50'"
        @click="navigate(item.path)"
      >{{ item.label }}</span>
    </div>
  </header>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import UiMixin from '@/util/UiMixin'

  const SAMERGO_REGIONS = [
    { key: 'albrandswaard', label: 'Albrandswaard', lat: 51.8557, lon: 4.4108, portfolio: 'lDnrgjNkQJ' },
    { key: 'barendrecht', label: 'Barendrecht', lat: 51.8553, lon: 4.5347, portfolio: 'JjVgNKmx2p' },
    { key: 'goeree-overflakkee', label: 'Goeree-Overflakkee', lat: 51.7453, lon: 4.0653, portfolio: '4EnmG5axQr' },
    { key: 'nissewaard', label: 'Nissewaard', lat: 51.8353, lon: 4.2697, portfolio: 'gXVp4APVQp' },
    { key: 'ridderkerk', label: 'Ridderkerk', lat: 51.8653, lon: 4.5967, portfolio: 'bGnGaejxNX' },
    { key: 'voorne-aan-zee', label: 'Voorne aan Zee', lat: 51.8753, lon: 4.0567, portfolio: 'GZx6lRjn8A' },
    { key: 'hoeksche-waard', label: 'Hoeksche-Waard', lat: 51.806599, lon: 4.348712, portfolio: 'RLn7EmEx0w' },
  ]

  export default defineComponent({
    name: 'TopBarStaticSamergo',
    mixins: [UiMixin],
    data() {
      return {
        mobileMenuOpen: false,
      }
    },
    computed: {
      profile() {
        return this.$store.state.user.profile || {}
      },
      myRegionPortfolio(): string | undefined {
        const region = SAMERGO_REGIONS.find(r => r.key === this.profile.samergo_region)
        return region?.portfolio
      },
      navItems(): Array<{ key: string; label: string; path: string }> {
        return [
          { key: 'home', label: this.$t('samergo_nav_home'), path: '/dashboards/home' },
          { key: 'mijn-wijk', label: this.$t('samergo_nav_my_network'), path: '/my-network' },
          { key: 'regio', label: this.$t('samergo_nav_regio'), path: '/regio' },
          //{ key: 'regio', label: this.$t('samergo_nav_regio'), path: '/actors-simplified?zhebar=2&portfolio=' + this.myRegionPortfolio },
          { key: 'zhebar', label: 'ZHE-BAR', path: '/actors-simplified?zhebar=1&portfolio=AekDJaLV24' },
          { key: 'rond-zhebar', label: this.$t('samergo_nav_rond_zhebar'), path: '/actors-simplified?rond-zhebar=1&portfolio=LwVYMvrVDG' },
          { key: 'communities', label: this.$t('samergo_nav_communities'), path: '/communities' },
        ]
      },
    },
    methods: {
      navigate(path: string) {
        this.mobileMenuOpen = false
        this.$router.push(path)
      },
      checkIsActive(key: string): boolean {
        const path = this.$route.path
        const query = this.$route.query
        if (key === 'home') return path.startsWith('/dashboards/home')
        if (key === 'mijn-wijk') return path.startsWith('/my-network')
        //if (key === 'regio') return path.startsWith('/actors-simplified') && query.zhebar == 2
        if (key === 'regio') return path.startsWith('/regio')
        if (key === 'zhebar') return path.startsWith('/actors-simplified') && query.zhebar == 1
        if (key === 'rond-zhebar') return path.startsWith('/actors-simplified') && !!query['rond-zhebar']
        if (key === 'communities') return path.indexOf('communities') >= 0
        return false
      },
    },
  })
</script>
